// buildBlastRadiusGate — VDE-10. Single shared constructor for the Slice H3
// `BlastRadiusGate` object. The Designer (`render/table/TableEditor.tsx`) and
// the inline Query-Editor toolbar (`inline/useInlineDdlBlastRadiusGate.ts`)
// previously hand-built field-identical literals that differed only by the
// `source` discriminant; this factory de-duplicates them so the parity is
// structural, not maintained by hand. Pure and behavior-preserving — it
// returns the same object both call sites used to inline. `resolveDependents`
// is intentionally omitted so `commitDdlEdit`'s `dependentsForDropEdit`
// default applies at both surfaces.

import type { BlastRadiusGate } from '../edit/commitDdlEdit';

export type BuildBlastRadiusGateArgs = Pick<
  BlastRadiusGate,
  'setPendingBlastRadius' | 'annotations' | 'source' | 'target'
> & {
  /** VDE-9 fail-safe: only trust `annotations` once the query is a confirmed
   *  success for this target — otherwise dependents are UNKNOWN and the drop
   *  must force the blast-radius confirmation. */
  readonly annotationsReady: boolean;
};

export function buildBlastRadiusGate(
  args: BuildBlastRadiusGateArgs,
): BlastRadiusGate {
  return {
    setPendingBlastRadius: args.setPendingBlastRadius,
    annotations: args.annotations,
    annotationsReady: args.annotationsReady,
    source: args.source,
    target: {
      schema: args.target.schema,
      objectName: args.target.objectName,
    },
  };
}
